module.exports = __webpack_public_path__ + "img/mlhg_btn_hover.f278ebfa.png";